export default __webpack_public_path__ + "static/image-BUIE-sample-34b9a95b2a6fc7f65b87850001b520a9.png";